import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as urlTemplate from 'url-template';

import { isNullOrUndefined } from '@app/util/util';
import { environment as ENV } from '@environment';
import { HomeItemDetail } from '@home-item-detail/entities/home-item-detail';
import { homeItemDetailApi, USER_ID } from '@home-item-detail/home-item-detail.api';
import { HomeFlightOffers } from '@shared/home-sections/entities/home-data.response';
import { TravelCmsHomeItemDetailPayload } from '@home/entities/travel-cms';
import { AuthService } from '@app/services/auth.service';
import { IS_MOBILE } from '@app/modules/core/tokens/app.tokens';
import { homeApi } from '@app/modules/home/home.api';

@Injectable()
export class HomeItemDetailService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    @Inject(IS_MOBILE) public isMobile: boolean) { }

  public fetchHomeItemDetail(payload: TravelCmsHomeItemDetailPayload): Observable<HomeItemDetail> {
    const headers = this.getHeaders(ENV.x_application_id);
    let url = urlTemplate.parse(homeApi.home_data).expand({
      pageCode: payload.pageCode,
      userId: payload.userId,
      isPrime: payload.isPrime,
      loyalty: payload.loyalty,
      isMobile: this.isMobile,
      treatments: payload.treatments,
      levelPrime: payload.levelPrime
    });
    if (isNullOrUndefined(payload.userId)) {
      const sliceIndex = url.indexOf(`&${USER_ID}`);
      url = url.substr(0, sliceIndex);
    }
    return this.http.get<HomeItemDetail>(url, { headers });
  }

  public fetchFlightOffers(departure: string, arrival: string, isOneWay: number): Observable<(HomeFlightOffers)[]> {
    const headers = this.getHeaders(ENV.x_application_id);
    const url = urlTemplate.parse(homeItemDetailApi.home_flight_offers).expand({
      departure: departure,
      arrival: arrival,
      oneway: isOneWay,
      limit: 3
    });
    return this.http.get<(HomeFlightOffers)[]>(url, { headers });
  }

  private getHeaders(applicationID: string = null): HttpHeaders {
    const params = {};
    if (applicationID) params['X_Application_ID'] = applicationID;
    return new HttpHeaders(params);
  }

}
